import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import ProductionMachines34_2aTable from "./Table";
import { ShowHide } from "../../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";

const ProductionMachines34_2a = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("PRODUCTION_MACHINES_EQUIPMENT") || "Production Machines/Equipment"}
        subDescription={t("PRODUCTION_MACHINES_34_2A_DESC") || "Enter production machines and equipment energy usage"}
        isNormal={true}
        number={"34.2a"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`production-machines-34-2a-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <ProductionMachines34_2aTable productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default ProductionMachines34_2a;
